import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import "./Contact.css";
const Contact = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleEmail = (e) => {
    setEmail(e.target.value);
    console.log(email);
  };
  const handleName = (e) => {
    setName(e.target.value);
    console.log(name);
  };

  const handlePhone = (e) => {
    let inputPhone = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    inputPhone = inputPhone.slice(0, 10); // Limit to 10 digits
    setPhone(inputPhone);
    console.log(phone);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
    console.log(message);
  };
  
  const sendEmail = async (e) => {
    e.preventDefault();
    const res = await fetch("/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        name,
        phone,
        message
      }),
    });
  
    if (res.ok) {
      // Reset form fields after successful submission
      setEmail("");
      setName("");
      setPhone("");
      setMessage("");
    } else {
      // Handle error case here
      console.error('Failed to submit form');
    }
  
    console.log(res);
  };
  
  

  return (
    <>
      <div className="container-fluid mt-100">
        <div className="row">
          <div className="col-md-12 position-relative p-0">
            <img src="./About.jpg" className="img-fluid" alt="" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="heading">
              Contact <span>Us</span>
            </h1>
            <div className="formPan">
              <h2>Get in touch with us!</h2>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <ul>
                    <li>
                      <Form.Control
                        type="email"
                        placeholder="Your Name *"
                        onChange={handleName}
                      />
                    </li>
                    <li>
                      <Form.Control
                        type="text"
                        placeholder="Email Address *"
                        onChange={handleEmail}
                      />
                    </li>
                    <li>
                      <Form.Control
                        type="tel"
                        placeholder="Enter Phone *"
                        onChange={handlePhone}
                        value={phone}
                      />
                    </li>

                    <li>
                      <textarea name="comment" rows="10" placeholder="Enter your message here..." onChange={handleMessage}>
                      </textarea>
                    </li>
                    
                  </ul>
                </Form.Group>
                <ul>
                  <li> <Button  type="submit" onClick={sendEmail}>
                  SEND
                </Button></li>
                </ul>
               
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
 
};

export default Contact;
